import { styled } from "../../Theme";

export const MainContainer = styled.div<{ background: string }>`
  display: flex;
  flex-direction: column;
  background-image: url(${({ background }) => background});
  background-attachment: fixed;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100% 100%;
  position: relative;
  min-height: 100vh;
  max-height: 100vh;
  justify-content: space-around;
  @media (max-width: ${(props) => props.theme.mobileFirst.breakPoint}) {
    max-height: initial;
  }
`;

export const LandingPageContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 100%;
  align-items: center;
  align-self: center;
`;

export const LogoLandingPageContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 15em;
  height: 5em;
  align-self: top;
`;

interface LandingPageProps {
  image: string;
}

export const LandingPageImageContainer = styled.div`
  width: 50%;
  height: 20em;
  align-self: center;
`;

export const Illustration = styled.div<LandingPageProps>`
  background-image: ${(props) => `url(${props.image})`};
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  height: 100%;
  width: 100%;
`;

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  @media (max-width: ${(props) => props.theme.mobileFirst.breakPoint}) {
    flex-direction: column;
  }
`;

export const Title = styled.div`
  padding: 4em;
  font-family: "Title", cursive;
  color: white;
  text-align: center;
  padding: 0.1em;
  font-size: 3.4em;
  box-sizing: border-box;
  width: 100%;
  white-space: wrap;
  margin-top: 0.5em;

  @media (max-width: ${(props) => props.theme.mobileFirst.breakPoint}) {
    font-size: 3.6em;
    margin-top: 0;
  }
`;

export const MiddleTitleContainer = styled.div`
  width: 100%;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const DashedLineSeparator = styled.div`
  border-bottom: solid white 0.2em;
  color: white;
  align-self: center;
  width: 100%;
`;

export const Subtitle = styled.div`
  width: 100%;
  min-width: 4em;
  color: white;
  text-align: center;
  padding: 0.5em;
  font-size: 1.3em;
  box-sizing: border-box;

  @media (max-width: ${(props) => props.theme.mobileFirst.breakPoint}) {
    font-size: 1.5em;
    white-space: wrap;
  }
`;

export const Description = styled.div`
  color: white;
  max-width: 40%;
  font-size: 1.2em;
  padding-top: 1em;
  padding-bottom: 1em;
  text-align: center;
  @media (max-width: ${(props) => props.theme.mobileFirst.breakPoint}) {
    max-width: 90%;
  }
`;

export const TimePill = styled.div`
  margin: auto;
  margin-left: 110px;
  color: #fff;
  padding: 0.1em;
  width: 5em;
  height: 5em;
  background-color: ${(props) => props.theme.color.highlightColor};
  border-radius: 3em;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  box-shadow: 0px 2px 5px 2px rgba(0, 0, 0, 0.24);
  border: solid #fff 0.1em;
  @media (max-width: ${(props) => props.theme.mobileFirst.breakPoint}) {
    margin-left: auto;
  }
`;

export const TimeTitle = styled.span`
  font-weight: bold;
  font-size: 1.7em;
  vertical-align: text-bottom;
  display: inline-block;
`;

export const LogoContainer = styled.div`
  display: flex;
  justify-content: center;
  vertical-align: center;
  padding: 1em;
  height: 10%;
  margin-bottom: 1em;
`;
